const Services = () => {
  return (
    <div className="py-20 bg-white">
      <div className="container mx-auto px-4 lg:px-20">
        <div className="text-center mb-10">
          <h6 className="inline-block text-primary relative pl-4 font-semibold">
            Our Services
          </h6>
          <h2 className="mt-2 text-3xl font-bold">What Solutions We Provide</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          <div className="service-item bg-gray-50 p-6 rounded shadow text-center flex flex-col items-center transition duration-300 hover:shadow-lg">
            <div className="text-primary mb-4 text-4xl service-icon">
              <i className="fa fa-truck"></i>
            </div>
            <h5 className="text-xl font-semibold mb-3">Fleet management</h5>
            <p className="text-gray-600 mb-4">
              Erat ipsum justo amet duo et elitr dolor, est duo duo eos lorem
              sed diam stet diam sed stet lorem.
            </p>
            <a
              href="#"
              className="btn bg-primary text-white px-4 py-2 rounded mt-auto"
            >
              Read More
            </a>
          </div>
          <div className="service-item bg-gray-50 p-6 rounded shadow text-center flex flex-col items-center transition duration-300 hover:shadow-lg">
            <div className="text-primary mb-4 text-4xl service-icon">
              <i className="fa-solid fa-map-location-dot"></i>
            </div>
            <h5 className="text-xl font-semibold mb-3">Tracking</h5>
            <p className="text-gray-600 mb-4">
              Erat ipsum justo amet duo et elitr dolor, est duo duo eos lorem
              sed diam stet diam sed stet lorem.
            </p>
            <a
              href="#"
              className="btn bg-primary text-white px-4 py-2 rounded mt-auto"
            >
              Read More
            </a>
          </div>
          <div className="service-item bg-gray-50 p-6 rounded shadow text-center flex flex-col items-center transition duration-300 hover:shadow-lg">
            <div className="text-primary mb-4 text-4xl service-icon">
              <i className="fa-solid fa-clone"></i>
            </div>
            <h5 className="text-xl font-semibold mb-3">Advance CRM</h5>
            <p className="text-gray-600 mb-4">
              Erat ipsum justo amet duo et elitr dolor, est duo duo eos lorem
              sed diam stet diam sed stet lorem.
            </p>
            <a
              href="#"
              className="btn bg-primary text-white px-4 py-2 rounded mt-auto"
            >
              Read More
            </a>
          </div>
          <div className="service-item bg-gray-50 p-6 rounded shadow text-center flex flex-col items-center transition duration-300 hover:shadow-lg">
            <div className="text-primary mb-4 text-4xl service-icon">
              <i className="fa-solid fa-file-invoice"></i>
            </div>
            <h5 className="text-xl font-semibold mb-3">Report Generate</h5>
            <p className="text-gray-600 mb-4">
              Erat ipsum justo amet duo et elitr dolor, est duo duo eos lorem
              sed diam stet diam sed stet lorem.
            </p>
            <a
              href="#"
              className="btn bg-primary text-white px-4 py-2 rounded mt-auto"
            >
              Read More
            </a>
          </div>
          <div className="service-item bg-gray-50 p-6 rounded shadow text-center flex flex-col items-center transition duration-300 hover:shadow-lg">
            <div className="text-primary mb-4 text-4xl service-icon">
              <i className="fa-solid fa-truck-ramp-box"></i>
            </div>
            <h5 className="text-xl font-semibold mb-3">Load Sourcing</h5>
            <p className="text-gray-600 mb-4">
              Erat ipsum justo amet duo et elitr dolor, est duo duo eos lorem
              sed diam stet diam sed stet lorem.
            </p>
            <a
              href="#"
              className="btn bg-primary text-white px-4 py-2 rounded mt-auto"
            >
              Read More
            </a>
          </div>
          <div className="service-item bg-gray-50 p-6 rounded shadow text-center flex flex-col items-center transition duration-300 hover:shadow-lg">
            <div className="text-primary mb-4 text-4xl service-icon">
              <i className="fa-solid fa-mobile-screen"></i>
            </div>
            <h5 className="text-xl font-semibold mb-3">Driver App</h5>
            <p className="text-gray-600 mb-4">
              Erat ipsum justo amet duo et elitr dolor, est duo duo eos lorem
              sed diam stet diam sed stet lorem.
            </p>
            <a
              href="#"
              className="btn bg-primary text-white px-4 py-2 rounded mt-auto"
            >
              Read More
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Services;
